export default __webpack_public_path__ + "static/media/bg_video.cf8da343.mp4";